import { render, staticRenderFns } from "./MenuTime.vue?vue&type=template&id=22e76249"
import script from "./MenuTime.vue?vue&type=script&lang=js"
export * from "./MenuTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports